<div class="animate-fade-in">
    <app-data-table title="Organizaciones"
        description="Administra los perfiles corporativos y la configuración global de tus empresas"
        icon="solar:buildings-bold-duotone" [loading]="loading()" [total]="pagination().total"
        [dataSource]="businesses()" [columns]="columns" [pagination]="pagination()" (onSearch)="handleSearch($event)"
        (onReload)="businessResource.reload()" (onPageChange)="handlePageChange($event)"
        (onLimitChange)="handleLimitChange($event)" [columnTemplates]="{
       'name': nameTmpl,
       'codes': codesTmpl,
       'taxId': taxTmpl,
       'isEnabled': statusTmpl,
       'createdAt': dateTmpl,     
       'actions':     actionsTmpl  
    }">
        <!-- Metrics Slot -->
        <ng-template #metrics>
            <app-metrics [items]="metricsItems()"></app-metrics>
        </ng-template>

        <ng-template #actionGroup>
            <app-button variant="glass" size="md" [square]="true" [spinIconOnHover]="true" class="p-2"
                routerLink="/app/business/new" title="Nueva Empresa" [iconLeft]="'mdi:plus'">
            </app-button>
        </ng-template>

        <ng-template #nameTmpl let-business>
            <div class="flex flex-col gap-0.5">
                <div class="flex items-center gap-2">
                    <span class="text-foreground font-black tracking-tight">{{ business.commercialName || business.name
                        }}</span>
                    <app-badge *ngIf="business.isSpecialTaxpayer" size="xs" variant="primary"
                        class="text-[8px] px-1 py-0 h-4">CE</app-badge>
                </div>
                <span class="text-[10px] text-foreground/75 font-bold uppercase">{{ business.name }}</span>
            </div>
        </ng-template>

        <ng-template #codesTmpl let-business>
            <div class="flex flex-col">
                <span class="text-[11px] font-bold text-slate-800 dark:text-white/90/60 tracking-tighter">EST: {{
                    business.establishmentCode }}</span>
                <span class="text-[11px] font-bold text-slate-800 dark:text-white/90/60 tracking-tighter">P.E: {{
                    business.emissionPointCode }}</span>
            </div>
        </ng-template>

        <ng-template #taxTmpl let-business>
            <span class="text-xs font-bold text-foreground/75 tracking-tight">{{ business.taxId }}</span>
        </ng-template>

        <ng-template #statusTmpl let-business>
            <app-badge [variant]="business.isEnabled !== false ? 'success' : 'danger'">
                {{ business.isEnabled !== false ? 'Activa' : 'Suspendida' }}
            </app-badge>
        </ng-template>

        <ng-template #dateTmpl let-business>
            <span class="text-[11px] font-bold text-foreground/60 uppercase tracking-widest">{{ business.createdAt |
                date:'dd MMM, yyyy' }}</span>
        </ng-template>
        <ng-template #actionsTmpl let-business>
            <div class="flex items-center justify-end gap-1">
                <app-button variant="glass" size="xs" [square]="true" (btnClick)="viewDetails(business)" class="p-1"
                    iconLeft="solar:eye-bold-duotone" title="Ver Detalles" color="text-blue-500"
                    hover="hover:text-blue-600 hover:border-blue-500/30 hover:bg-blue-500/5">
                </app-button>
                <app-button *ngIf="authService.hasPermission('memberships:view')" 
                    variant="glass" size="xs" [square]="true" class="p-1"
                    [routerLink]="['/app/business/membership', business._id || business.id]"
                    iconLeft="solar:card-2-bold-duotone" title="Membresía" color="text-amber-500"
                    hover="hover:text-amber-600 hover:border-amber-500/30 hover:bg-amber-500/5">
                </app-button>
                <app-button *ngIf="!authService.hasPermission('memberships:view') && authService.hasPermission('memberships:assign')" 
                    variant="glass" size="xs" [square]="true" (btnClick)="openMembership(business)" class="p-1"
                    iconLeft="solar:card-2-bold-duotone" title="Membresía" color="text-amber-500"
                    hover="hover:text-amber-600 hover:border-amber-500/30 hover:bg-amber-500/5">
                </app-button>
                <app-button variant="glass" size="xs" [square]="true" color="text-green-500" class="p-1"
                    [routerLink]="['/app/business/edit', business._id || business.id]"
                    iconLeft="solar:pen-new-square-linear" title="Editar"
                    hover="hover:text-green-600 hover:border-green-500/30 hover:bg-green-500/5">
                </app-button>
                <app-button variant="glass" size="xs" [square]="true" class="p-1"
                    (btnClick)="deleteBusiness(business._id || business.id)"
                    iconLeft="solar:trash-bin-minimalistic-linear" title="Eliminar" color="text-red-500"
                    hover="hover:text-red-600 hover:border-red-500/30 hover:bg-red-500/5">
                </app-button>
            </div>
        </ng-template>

    </app-data-table>

    <!-- ── Modal de Detalles Ultra Compacto ────────────────────────────────────── -->
    <app-modal [isOpen]="showDetails()" (isOpenChange)="showDetails.set($event)"
        [title]="selectedBusiness() ? selectedBusiness()!.commercialName || selectedBusiness()!.name : ''"
        icon="solar:buildings-bold-duotone">

        <div class="space-y-4 py-1" *ngIf="selectedBusiness() as biz">
            <!-- Bloque de Identidad Principal -->
            <div class="flex items-center gap-4 p-4 bg-primary/[0.03] rounded-3xl border border-primary/10 relative overflow-hidden group">
                <div class="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-50"></div>
                
                <div class="relative w-16 h-16 rounded-2xl bg-white flex items-center justify-center shadow-sm border border-foreground/[0.03] shrink-0 overflow-hidden z-10 transition-transform group-hover:scale-105">
                    <img *ngIf="biz.invoiceLogoUrl" [src]="getLogoUrl(biz.invoiceLogoUrl)" class="w-full h-full object-contain p-2" />
                    <iconify-icon *ngIf="!biz.invoiceLogoUrl" icon="solar:buildings-bold-duotone" class="text-3xl text-primary/40"></iconify-icon>
                </div>

                <div class="flex flex-col min-w-0 z-10">
                    <h2 class="text-lg font-bold text-slate-800 dark:text-white/90 uppercase tracking-tight truncate leading-tight mb-0.5">
                        {{ biz.commercialName || biz.name }}
                    </h2>
                    <p class="text-[9px] font-bold text-foreground/75 uppercase tracking-[0.2em] truncate italic mb-2">
                        {{ biz.name }}
                    </p>
                    <div class="flex flex-wrap items-center gap-2">
                        <app-badge [variant]="biz.isEnabled !== false ? 'success' : 'danger'" size="xs" class="text-[8px] font-black tracking-widest px-2">
                            {{ biz.isEnabled !== false ? 'ENTIDAD ACTIVA' : 'SISTEMA SUSPENDIDO' }}
                        </app-badge>
                        <app-badge *ngIf="biz.isSpecialTaxpayer" variant="primary" size="xs" class="text-[8px] font-black tracking-widest px-2">
                            Contribuyente Especial
                        </app-badge>
                    </div>
                </div>
            </div>

            <!-- Grid de Información Técnica & SRI -->
            <div class="grid grid-cols-2 gap-3">
                <!-- RUC / ID -->
                <div class="flex items-center gap-3 p-3 bg-foreground/[0.02] rounded-2xl border border-foreground/[0.03] transition-all hover:border-primary/20">
                    <div class="w-8 h-8 rounded-lg bg-blue-500/10 flex items-center justify-center text-blue-500 shrink-0">
                        <iconify-icon icon="solar:card-2-bold-duotone" width="18"></iconify-icon>
                    </div>
                    <div>
                        <p class="text-[8px] font-bold text-slate-800 dark:text-white/90/30 uppercase tracking-widest mb-0.5">Identificación Fiscal</p>
                        <p class="text-[11px] font-bold text-slate-800 dark:text-white/90 tracking-tight leading-none">{{ biz.taxId }}</p>
                    </div>
                </div>

                <!-- Límite de Personal (Nuevo) -->
                <div class="flex items-center gap-3 p-3 bg-foreground/[0.02] rounded-2xl border border-foreground/[0.03] transition-all hover:border-primary/20">
                    <div class="w-8 h-8 rounded-lg bg-purple-500/10 flex items-center justify-center text-purple-500 shrink-0">
                        <iconify-icon icon="solar:users-group-two-rounded-bold-duotone" width="18"></iconify-icon>
                    </div>
                    <div>
                        <p class="text-[8px] font-bold text-slate-800 dark:text-white/90/30 uppercase tracking-widest mb-0.5">Límite de Equipo</p>
                        <p class="text-[11px] font-bold text-slate-800 dark:text-white/90 leading-none">
                            {{ biz.staffLimit ? biz.staffLimit + ' USUARIOS' : 'ESTADO ILIMITADO' }}
                        </p>
                    </div>
                </div>

                <!-- Códigos SRI -->
                <div class="col-span-2 grid grid-cols-2 gap-3 p-3 bg-orange-500/[0.02] rounded-2xl border border-orange-500/[0.08]">
                    <div class="flex items-center gap-3">
                        <div class="w-8 h-8 rounded-lg bg-orange-500/10 flex items-center justify-center text-orange-500 shrink-0">
                            <iconify-icon icon="solar:shop-2-bold-duotone" width="18"></iconify-icon>
                        </div>
                        <div>
                            <p class="text-[8px] font-bold text-slate-800 dark:text-white/90/30 uppercase tracking-widest mb-0.5">Establecimiento</p>
                            <p class="text-[12px] font-bold text-slate-800 dark:text-white/90 leading-none">{{ biz.establishmentCode || '---' }}</p>
                        </div>
                    </div>
                    <div class="flex items-center gap-3 border-l border-orange-500/10 pl-3">
                        <div class="w-8 h-8 rounded-lg bg-orange-500/10 flex items-center justify-center text-orange-500 shrink-0">
                            <iconify-icon icon="solar:printer-bold-duotone" width="18"></iconify-icon>
                        </div>
                        <div>
                            <p class="text-[8px] font-bold text-slate-800 dark:text-white/90/30 uppercase tracking-widest mb-0.5">Punto de Emisión</p>
                            <p class="text-[12px] font-bold text-slate-800 dark:text-white/90 leading-none">{{ biz.emissionPointCode || '---' }}</p>
                        </div>
                    </div>
                </div>

                <!-- Bloque de Contacto (Gris/Muted) -->
                <div class="col-span-2 p-4 bg-foreground/[0.03] rounded-3xl border border-foreground/[0.05] space-y-3">
                    <div class="flex flex-wrap items-center gap-x-6 gap-y-2">
                        <div class="flex items-center gap-2">
                            <div class="w-5 h-5 rounded-full bg-primary/10 flex items-center justify-center text-primary">
                                <iconify-icon icon="solar:phone-bold" width="10"></iconify-icon>
                            </div>
                            <span class="text-[10px] font-bold text-slate-800 dark:text-white/90/60 tracking-tight">{{ biz.phone || 'S/T' }}</span>
                        </div>
                        <div class="flex items-center gap-2">
                            <div class="w-5 h-5 rounded-full bg-primary/10 flex items-center justify-center text-primary">
                                <iconify-icon icon="solar:letter-bold" width="10"></iconify-icon>
                            </div>
                            <span class="text-[10px] font-bold text-slate-800 dark:text-white/90/60 tracking-tight lowercase">{{ biz.email }}</span>
                        </div>
                    </div>
                    
                    <div class="pt-3 border-t border-foreground/[0.05] flex items-start gap-2.5">
                        <div class="w-5 h-5 rounded-full bg-primary/10 flex items-center justify-center text-primary shrink-0 mt-0.5">
                            <iconify-icon icon="solar:map-point-bold" width="10"></iconify-icon>
                        </div>
                        <p class="text-[10px] font-bold text-foreground/50 uppercase leading-snug tracking-wide">
                            {{ biz.address || 'Ubicación no registrada' }}
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div actions class="flex justify-end items-center gap-3 w-full">
            <app-button *ngIf="authService.hasPermission('memberships:view')" 
                variant="glass" size="xs" [routerLink]="['/app/business/membership', selectedBusiness()?._id]" (btnClick)="showDetails.set(false)"
                color="text-amber-500" iconLeft="solar:card-2-bold-duotone">
                Membresía
            </app-button>
            <app-button *ngIf="!authService.hasPermission('memberships:view') && authService.hasPermission('memberships:assign')" 
                variant="glass" size="xs" (btnClick)="openMembership(selectedBusiness()!); showDetails.set(false)"
                color="text-amber-500" iconLeft="solar:card-2-bold-duotone">
                Membresía
            </app-button>
            <app-button variant="glass" size="xs" [routerLink]="['/app/business/edit', selectedBusiness()?._id]"
                color="text-blue-500" iconLeft="solar:pen-new-square-bold" (btnClick)="showDetails.set(false)">
                Editar Organización
            </app-button>
            <app-button variant="primary" size="xs" (btnClick)="showDetails.set(false)"
                iconLeft="solar:close-circle-bold">
                Cerrar
            </app-button>
        </div>
    </app-modal>

    <app-membership-assign-dialog
        [isOpen]="showMembershipDialog()"
        [businessId]="selectedBusiness()?._id || selectedBusiness()?.id || ''"
        [businessName]="selectedBusiness()?.commercialName || selectedBusiness()?.name || ''"
        (onClose)="showMembershipDialog.set(false)"
        (onSave)="businessResource.reload(); showMembershipDialog.set(false)">
    </app-membership-assign-dialog>
</div>